export var SectionName;
(function (SectionName) {
    SectionName["General"] = "general";
    SectionName["Help"] = "help";
    SectionName["Payment"] = "payment";
    SectionName["Shipping"] = "shipping";
    SectionName["International"] = "international";
    SectionName["Social"] = "social";
})(SectionName || (SectionName = {}));
